module.exports = __webpack_public_path__ + "static/img/five_icon.f2205a5.png";


//////////////////
// WEBPACK FOOTER
// ./static/mobile/five_icon.png
// module id = 1AyN
// module chunks = 2